<template>
  <div
    class="raise-slider rslid_container"
    :class="[{ 'no-events': readOnly }]"
  >
    <div class="rslid_raisegroups">
      <div
        v-for="group in raiseGroups"
        :key="group.id"
        v-ripple
        class="rslid_raisegroups_group capitalize csst csst_nm"
        @click="selectGroup(group)"
      >
        <span
          class="pl-1"
          v-html="getBetHtml({ showBetsIn, a: group.action, simple: true })"
        ></span>

        <div
          class="csst_content"
          style="position: fixed; transform: translate(0, -3rem); min-width: 200px"
        >
          <div class="weight_700 capitalize-all">
            {{ $t(`browse.${group.id}`) }}
          </div>
          {{ $t(`browse.${group.id}_help`) }}
        </div>
      </div>
    </div>
    <RangeInput
      :values="[
        {
          id: 1,
          percentage: slider,
          cssStyle: `
                --clr-input-back: var(--clr-R_default);
                --clr-input-handle: var(--clr-R_default);
                `,
        },
        {
          id: 2,
          percentage: 1 - slider,
          cssStyle: `
                     --clr-input-back: var(--clr-R_default);
                --clr-input-handle: var(--clr-R_default);
                `,
        },
      ]"
      style="--rainput-height: 1em; --rainput-clr-back: var(--clr-R_default)"
      @values:update="({ values }) => handleInput(values)"
    >
    </RangeInput>
  </div>
</template>

<script>
import RangeInput from '@/components/lib/RangeInput'
import format_mix from '@/mixins/format_mix'
import { getRaisesNonRaises, get4RaiseGroups } from '@/helpers/grouping'

export default {
  name: 'RaiseSlider',
  components: {
    RangeInput,
  },
  mixins: [format_mix],
  props: {
    actions: Array,
    readOnly: Boolean,
  }, 
 emits: ['update:raise','update:actions'],
  data() {
    return {
      slider: 0.5,
      selectedRaise: null,
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      if (!this.actions?.length) return
      this.setSliderPercent(0.5)
    },
    selectGroup(group) {
      const idx = this.raises.findIndex(i => i.code === group.action.code)
      this.setSlider(idx)
    },
    setSlider(idx) {
      const percent = this.unit * idx
      this.setSliderPercent(percent)
    },
    handleInput(values) {
      const raise = values[0].percentage
      this.setSliderPercent(raise)
    },
    setSliderPercent(percent) {
      this.slider = percent
      this.setSelectedRaise()
    },
    setSelectedRaise() {
      const rIndex = Math.round(this.slider / this.unit)
      this.selectedRaise = this.raises[rIndex]
      this.handleChange()
    },
    handleChange() {
      if (this.readOnly) return
      const res = [...this.nonRaises, this.selectedRaise].filter(i => i)
      this.$emit('update:raise', this.selectedRaise)
      this.$emit('update:actions', res)
    },
  },
  computed: {
    raisesNonRaises() {
      const { nonRaises, raises } = getRaisesNonRaises({ actions: this.actions })
      return { nonRaises, raises }
    },
    nonRaises() {
      return this.raisesNonRaises.nonRaises
    },
    raises() {
      return this.raisesNonRaises.raises
    },
    unit() {
      return 1 / this.minMax.max
    },
    minMax() {
      return {
        min: 0,
        max: this.raises.length - 1,
      }
    },
    raiseGroups() {
      let raiseGroups = get4RaiseGroups({ raises: this.raises, order: 'asc' })
      raiseGroups = raiseGroups.filter(i => i.actions.length)
      raiseGroups = raiseGroups.map(i => {
        let action = null
        if (i.actions.length === 1) {
          action = i.actions[0]
        }
        if (i.actions.length === 2) {
          action = i.actions[1]
        } else {
          const idx = Math.ceil((i.actions.length - 1) / 2)
          action = i.actions[idx]
        }
        return {
          ...i,
          action,
        }
      })
      // console.log(raiseGroups)
      return raiseGroups
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
  },
}
</script>
<style lang="scss" scoped>
.rslid_container {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  justify-content: center;
  grid-gap: 4px;
  margin: 0 0 4px 0;
}
.rslid_grid_3 {
  grid-template-columns: repeat(6, 1fr);
  grid-template-areas: '. . a a b b';
  .rslid_raisegroups {
    grid-area: a;
  }
  .rslid_slide-container {
    grid-area: b;
  }
}

.rslid {
  cursor: pointer;
  position: relative;
  &_wheel-trigger-cont {
    position: absolute;
    height: 100px;
    width: 100%;
    top: -40px;
    right: 0;
  }
  &_raisegroups {
    display: grid;
    grid-gap: 4px;
    width: 100%;
    flex-shrink: 0;
    grid-auto-flow: column;
    &_group {
      grid-auto-columns: auto;
      display: grid;
      grid-gap: 4px;
      flex: 1;
      background: var(--clr-black-1-2);
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      letter-spacing: 1.25px;
      &:hover {
        background: var(--clr-black-2);
      }
    }
  }
  &_slide-container {
    position: relative;
    height: 2rem;
    border-radius: 8px;
    margin: 0 0.25rem 0 0.25rem;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  &_range {
    position: relative;
    z-index: 0;
    left: 0;
    top: 0;
    height: 0.75rem;
    border-radius: 99px;
    background: var(--clr-R_default);
    width: 100%;
    display: flex;
    align-items: center;
  }
  &_slider {
    position: absolute;
    height: 1.5rem;
    &:before {
      border-radius: 99px;
      content: '';
      position: absolute;
      width: 0.8rem;
      height: 1.5rem;
      left: -0.4rem;
      box-shadow: 0.5px 0.5px 2px 1px rgb(0 0 0 / 32%);
      border: solid white 2px;
      background: var(--clr-R_default);
    }
  }
}
@media (max-width: 1023px) {
  .rslid {
    &_slide-container {
      margin: 0 0.25rem 0 0.25rem;
    }
  }
}
</style>
